import { useEffect, useState } from "react";
import { message, Select } from "antd";
import LayoutCss from "layout/layout.module.scss";
import { useParams } from "react-router-dom";
import CommissionPlan from "redux/models/commissionPlan";
import { merge } from "lodash";
import CurrentCommissionPlans from "./currentCommissionPlans";
import UpcomingCommissionPlans from "./upcomingCommissionPlans";
import HistoryCommissionPlans from "./historyCommissionPlans";
import { EditCommissionPlanModal } from "./editCommissionPlanModal";
import {isPermissionPresent} from "../../../../utilities/generalUtility";
import { useSelector } from "react-redux";
import { selectUser } from "redux/slices/userSlice";
import K from "../../../../utilities/constants";

export default function CommissionPlansDetail() {
  const { planId } = useParams();
  const [plansDetails, setPlansDetails] = useState(null);
  const [commissionPlan, setCommissionPlan] = useState("upcomingPlans");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const userSlice = useSelector(selectUser);

  const isEditAllowed = isPermissionPresent(
    K.Permissions.EditCommissionPlan,
    userSlice.roles,
  );

  const getCommissionPlansById = async () => {
    try {
      const res = await CommissionPlan.getCommissionPlans(planId);
      setPlansDetails(res);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getCommissionPlansById();
  }, []);

  const commissionPlansComponents = {
    upcomingPlans: (
      <UpcomingCommissionPlans
        plansDetails={plansDetails}
        setPlansDetails={setPlansDetails}
        getCommissionPlansById={getCommissionPlansById}
        isEditAllowed={isEditAllowed}
      />
    ),
    historyPlans: <HistoryCommissionPlans plansDetails={plansDetails} />,
  };

  const onFinishEdit = async (values) => {
    try {
      setLoading(true);
      const res = await CommissionPlan.editCommission(planId, {
        name: values.name,
      });
      setPlansDetails((prev) => ({
        ...prev,
        basicInfo: { ...prev.basicInfo, name: res.data.name },
      }));
      message.success("Commission Plan name successfully updated");
    } catch (e) {
      message.error(e.message);
      console.error(e);
    } finally {
      setEditModalVisible(false);
      setLoading(false);
    }
  };

  const onStartDateUpdated = (newStartDate) => {
    setPlansDetails((prev) =>
      merge({}, prev, {
        currentRule: { defaultPlan: { startDate: newStartDate } },
      }),
    );
  };

  return (
    <>
      {plansDetails && (
        <CurrentCommissionPlans
          plansDetails={plansDetails}
          setEditModalVisible={setEditModalVisible}
          onStartDateUpdated={onStartDateUpdated}
          isEditAllowed={isEditAllowed}
        />
      )}
      <div className={LayoutCss.invoicesButton}>
        <Select
          showSearch={false}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          defaultValue="upcomingPlans"
          onChange={(value) => setCommissionPlan(value)}
          className={LayoutCss.invoicesButtonSet}
          options={[
            { value: "historyPlans", label: "History" },
            { value: "upcomingPlans", label: "Upcoming" },
          ]}
        />
      </div>
      {plansDetails && commissionPlansComponents[commissionPlan]}
      {editModalVisible && (
        <EditCommissionPlanModal
          defaultValues={plansDetails.basicInfo}
          loading={loading}
          modalVisible={editModalVisible}
          setEditModalVisible={setEditModalVisible}
          onFinish={onFinishEdit}
        />
      )}
    </>
  );
}
